import Icon from '../components/Icon.vue'

Icon.register({
  'grin-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM281.8 197.7L361.8 149.7C373.4 142.8 385.8 157.4 377.2 167.7L343.6 208 377.2 248.3C385.9 258.7 373.3 273.1 361.8 266.3L281.8 218.3C274.1 213.6 274.1 202.4 281.8 197.7zM118.8 167.7C110.2 157.4 122.6 142.8 134.2 149.7L214.2 197.7C222 202.4 222 213.6 214.2 218.3L134.2 266.3C122.7 273.1 110.2 258.7 118.8 248.3L152.4 208 118.8 167.7zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.8 113.6 317.1 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.6 317.1 393.7 327 391.8 338.7 382.5 393.7 308.6 432 248 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-squint.js
// module id = 8Fo6
// module chunks = 144